module.exports = __webpack_public_path__ + "img/model-banner.4cf471df.svg";